import {PdxBanner} from 'uScope/js/extensions/pdx-support/PdxBanner';
import app from '../../public-api';

const loader = {
  name: 'us:pdx-banner',

  extends: 'viewport',

  constructor: PdxBanner
};

app.plugins.register(loader);



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/pdx-support/pdx-banner-loader.js